/**
 * @desc 导出交易明细列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.OilCompanyCardTopUpEntities): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/base/company/card/exportCardDetails',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
